import { all, call } from "redux-saga/effects";
import onGetTopic from "./getTopics";
import onGetAllTopics from "./getAllTopics";
import onTopicDelete from "./deleteTopic";

export default function* topicSagas() {
  yield all([call(onGetTopic), call(onGetAllTopics), call(onTopicDelete)]);
}
